import { Builder } from '@builder.io/react';
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from '../BuilderComponentsName';
import { S37ReviewsOverall } from '../components/interactive-sections/S37ReviewsOverall';
import { getBackgroundColorInput, getBackgroundGradientInput, getPaddingInputs } from '../utils/builderSharedInputs';
import { backgroundGradientOptions, reviewsBackgroundColorOptions } from '../utils/builderColorOptions';

Builder.registerComponent(S37ReviewsOverall, {
    name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S37ReviewsOverall,
    friendlyName: 'S37 Reviews Overall',
    models: ['clinic-page'],
    inputs: [
        ...getBackgroundColorInput({
            defaultValue: 'GreyLt',
            backgroundColorsList: reviewsBackgroundColorOptions,
        }),
        ...getBackgroundGradientInput({
            backgroundGradientList: backgroundGradientOptions,
        }),
        ...getPaddingInputs(),
        {
            name: 'title',
            type: 'string',
            friendlyName: 'Title',
            helperText: 'The main heading displayed at the top of the reviews section',
            required: false,
            defaultValue: 'Real Clients, Real Results',
        },
    ],
});
